import React from "react"
import { Card, Page, Layout } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import { useAppContext } from "components/AppContext"
import useAuth0 from "components/auth/useAuth0"
import { Redirect } from "react-router-dom"

const UnauthorizedPage = () => {
  const { t } = useTranslation()
  const { hasAccessRights } = useAppContext()
  const { isAuthenticated } = useAuth0()

  if (isAuthenticated && hasAccessRights) return <Redirect to="/" />

  return (
    <Page narrowWidth>
      <Layout>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            backgroundColor: "#f6f6f7",
          }}
        >
          <Card sectioned>
            <div
              style={{
                textAlign: "center",
                padding: "2rem",
                maxWidth: "500px",
              }}
            >
              <h1
                style={{
                  fontSize: "2.2rem",
                  marginBottom: "3rem",
                  fontWeight: "600",
                  lineHeight: "normal",
                }}
              >
                {t("errors.unauthorized.title")}
              </h1>
              <p
                style={{
                  marginBottom: "1rem",
                  textAlign: "left",
                  fontSize: "normal",
                }}
              >
                {t("errors.unauthorized.error")}
              </p>
              <p style={{ textAlign: "left", fontSize: "normal" }}>
                {t("errors.unauthorized.cta")}
              </p>
            </div>
          </Card>
        </div>
      </Layout>
    </Page>
  )
}

export default UnauthorizedPage
